import script from "./AppleIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AppleIcon.vue?vue&type=script&setup=true&lang=js"

import "./AppleIcon.vue?vue&type=style&index=0&id=8601d8c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@5.111.1_postcss@8.5.29_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8601d8c8"]])

export default __exports__